// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multiSelectContainer--UI5iL {
  position: relative;
  width: 100%;
}

.selectInput--PAjBh {
  display: flex;
  align-items: center;
  min-height: 42px;
  position: relative;
  transition: all 0.15s;
}

[dir] .selectInput--PAjBh {
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: white;
  cursor: pointer;
}

[dir=ltr] .selectInput--PAjBh {
  padding: 4px 50px 4px 8px;
}

[dir=rtl] .selectInput--PAjBh {
  padding: 4px 8px 4px 50px;
}

[dir] .selectInput--PAjBh:hover {
  border-color: #9ca3af;
}

.selectInput--PAjBh:focus {
  outline: none;
}

[dir] .selectInput--PAjBh:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 2px #dbeafe;
}

[dir] .selectInput--PAjBh.open--kbAc9 {
  border-color: #2563eb;
  box-shadow: 0 0 0 2px #dbeafe;
}

.searchIconContainer--iqWMO {
  position: absolute;
  top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  pointer-events: none;
}

[dir] .searchIconContainer--iqWMO {
  transform: translateY(-50%);
}

[dir=ltr] .searchIconContainer--iqWMO {
  right: 32px;
}

[dir=rtl] .searchIconContainer--iqWMO {
  left: 32px;
}

.searchIcon--H48BR {
  width: 16px;
  height: 16px;
}

.clearButton--vZA8w {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
  color: #6b7280;
  pointer-events: auto;
}

[dir] .clearButton--vZA8w {
  background: none;
  border: none;
  cursor: pointer;
  padding: 2px;
  border-radius: 2px;
}

.clearButton--vZA8w:hover {
  color: #374151;
}

[dir] .clearButton--vZA8w:hover {
  background: #e5e7eb;
}

.selectedItems--En2bi {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: 4px;
  flex: 1;
  align-items: center;
  min-height: 32px;
  max-height: 160px;
  overflow-y: auto;
  overflow-x: hidden;
}

[dir=ltr] .selectedItems--En2bi {
  padding-right: 2px;
}

[dir=rtl] .selectedItems--En2bi {
  padding-left: 2px;
}

.selectedPill--XVipf {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #222;
  transition: all 0.15s;
  max-width: min(100%, 220px);
  min-width: 0;
  overflow: hidden;
}

[dir] .selectedPill--XVipf {
  background: #f9fafb;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

[dir=ltr] .selectedPill--XVipf {
  padding: 3px 4px 3px 6px;
}

[dir=rtl] .selectedPill--XVipf {
  padding: 3px 6px 3px 4px;
}

[dir] .selectedPill--XVipf:hover {
  background: #e5e7eb;
  border-color: #9ca3af;
}

.pillFlag--DNg8l {
  width: 16px;
  height: 16px;
  -o-object-fit: cover;
     object-fit: cover;
  flex-shrink: 0;
}

[dir] .pillFlag--DNg8l {
  border-radius: 50%;
}

[dir=ltr] .pillFlag--DNg8l {
  margin-right: 5px;
}

[dir=rtl] .pillFlag--DNg8l {
  margin-left: 5px;
}

.pillText--Ebglf {
  display: block;
  flex: 1;
  min-width: 0;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

[dir=ltr] .pillText--Ebglf {
  margin-right: 3px;
}

[dir=rtl] .pillText--Ebglf {
  margin-left: 3px;
}

.pillRemove--PHvYu {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
  color: #6b7280;
  flex-shrink: 0;
  width: auto !important;
}

[dir] .pillRemove--PHvYu {
  background: none;
  border: none;
  cursor: pointer;
  padding: 1px;
  border-radius: 2px;
}

.pillRemove--PHvYu:hover {
  color: #374151;
}

[dir] .pillRemove--PHvYu:hover {
  background: #e5e7eb;
}

.pillCloseIcon--SJpkF {
  width: 12px;
  height: 12px;
}

.searchInput--dAWnk {
  outline: none;
  font-size: 14px;
  flex: 1;
  min-width: 100px;
  color: #222;
  width: 100%;
  text-overflow: ellipsis;
}

[dir] .searchInput--dAWnk {
  border: none;
  background: none;
  padding: 4px 0;
}

.searchInput--dAWnk::-moz-placeholder {
  color: #9ca3af;
}

.searchInput--dAWnk::placeholder {
  color: #9ca3af;
}

.selectArrow--iluRC {
  position: absolute;
  top: 50%;
  color: #6b7280;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

[dir] .selectArrow--iluRC {
  transform: translateY(-50%);
}

[dir=ltr] .selectArrow--iluRC {
  right: 12px;
}

[dir=rtl] .selectArrow--iluRC {
  left: 12px;
}

.selectArrow--iluRC svg {
  transition: transform 0.2s;
}

[dir=ltr] .selectArrow--iluRC svg.arrowUp--u46ys {
  transform: rotate(180deg);
}

[dir=rtl] .selectArrow--iluRC svg.arrowUp--u46ys {
  transform: rotate(-180deg);
}

.dropdown--uPpRg {
  max-height: 200px;
  overflow-y: auto;
}

[dir] .dropdown--uPpRg {
  background: white;
  border: 1px solid #d1d5db;
  border-top: none;
  border-radius: 0 0 4px 4px;
}

.noResults--ja6wf {
  color: #6b7280;
  font-size: 14px;
}

[dir] .noResults--ja6wf {
  padding: 12px 16px;
  text-align: center;
}

.dropdownItem--O2ROV {
  display: flex;
  align-items: center;
  font-size: 14px;
  transition: background 0.15s;
}

[dir] .dropdownItem--O2ROV {
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
}

[dir] .dropdownItem--O2ROV:last-child {
  border-bottom: none;
}

[dir] .dropdownItem--O2ROV:hover {
  background: #f3f4f6;
}

[dir] .dropdownItem--O2ROV.selected--DCvW_ {
  background: #eff6ff;
}

[dir] .dropdownItem--O2ROV.selected--DCvW_:hover {
  background: #dbeafe;
}

.dropdownItem--O2ROV.focused--pU2uk {
  outline: 2px solid #2563eb;
  outline-offset: -2px;
}

[dir] .dropdownItem--O2ROV.focused--pU2uk {
  background: #e5e7eb;
}

[dir] .checkbox--Wswn8 {
  cursor: pointer;
}

[dir=ltr] .checkbox--Wswn8 {
  margin-right: 8px;
}

[dir=rtl] .checkbox--Wswn8 {
  margin-left: 8px;
}

.countryFlag--Fnnca {
  width: 20px;
  height: 20px;
  -o-object-fit: cover;
     object-fit: cover;
}

[dir] .countryFlag--Fnnca {
  border-radius: 50%;
}

[dir=ltr] .countryFlag--Fnnca {
  margin-right: 8px;
}

[dir=rtl] .countryFlag--Fnnca {
  margin-left: 8px;
}

.countryName--daUmF {
  flex: 1;
  color: #222;
}

/* Scrollbar styling for dropdown */
.dropdown--uPpRg::-webkit-scrollbar {
  width: 8px;
}

[dir] .dropdown--uPpRg::-webkit-scrollbar-track {
  background: #f3f4f6;
  border-radius: 4px;
}

[dir] .dropdown--uPpRg::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 4px;
}

[dir] .dropdown--uPpRg::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

/* Firefox scrollbar */
.dropdown--uPpRg {
  scrollbar-width: thin;
  scrollbar-color: #d1d5db #f3f4f6;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/CountryMultiSelect/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAMhB,kBAAkB;EAClB,qBAAqB;AACvB;;AAXA;EAKE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AAGjB;;AAXA;EAIE,yBAAyB;AAO3B;;AAXA;EAIE,yBAAyB;AAO3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AAGf;;AAJA;EAEE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAElB,QAAQ;EAER,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;AACtB;;AAVA;EAIE,2BAA2B;AAM7B;;AAVA;EAEE,WAAW;AAQb;;AAVA;EAEE,UAAW;AAQb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EAMvB,4BAA4B;EAC5B,cAAc;EACd,oBAAoB;AACtB;;AAZA;EAIE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;AAIpB;;AAEA;EAEE,cAAc;AAChB;;AAHA;EACE,mBAAmB;AAErB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AAEpB;;AAZA;EAWE,kBAAkB;AACpB;;AAZA;EAWE,iBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EAKnB,eAAe;EACf,WAAW;EAEX,qBAAqB;EACrB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;AAClB;;AAdA;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAIlB,yCAAyC;AAK3C;;AAdA;EAME,wBAAwB;AAQ1B;;AAdA;EAME,wBAAwB;AAQ1B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EAGZ,oBAAiB;KAAjB,iBAAiB;EACjB,cAAc;AAChB;;AAPA;EAGE,kBAAkB;AAIpB;;AAPA;EAIE,iBAAiB;AAGnB;;AAPA;EAIE,gBAAiB;AAGnB;;AAEA;EACE,cAAc;EACd,OAAO;EACP,YAAY;EACZ,gBAAgB;EAEhB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AATA;EAKE,iBAAiB;AAInB;;AATA;EAKE,gBAAiB;AAInB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EAMvB,4BAA4B;EAC5B,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAbA;EAIE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;AAKpB;;AAEA;EAEE,cAAc;AAChB;;AAHA;EACE,mBAAmB;AAErB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EAEE,aAAa;EAEb,eAAe;EACf,OAAO;EACP,gBAAgB;EAEhB,WAAW;EACX,WAAW;EACX,uBAAuB;AACzB;;AAXA;EACE,YAAY;EAEZ,gBAAgB;EAIhB,cAAc;AAIhB;;AAEA;EACE,cAAc;AAChB;;AAFA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAElB,QAAQ;EAER,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAVA;EAIE,2BAA2B;AAM7B;;AAVA;EAEE,WAAW;AAQb;;AAVA;EAEE,UAAW;AAQb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAFA;EACE,0BAAyB;AAC3B;;AAEA;EAKE,iBAAiB;EACjB,gBAAgB;AAClB;;AAPA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;AAG5B;;AAEA;EAGE,cAAc;EACd,eAAe;AACjB;;AALA;EACE,kBAAkB;EAClB,kBAAkB;AAGpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EAGnB,eAAe;EACf,4BAA4B;AAE9B;;AARA;EAGE,iBAAiB;EACjB,eAAe;EAGf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAEE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAJA;EACE,mBAAmB;AAGrB;;AAEA;EAEE,eAAe;AACjB;;AAHA;EACE,iBAAiB;AAEnB;;AAHA;EACE,gBAAiB;AAEnB;;AAEA;EACE,WAAW;EACX,YAAY;EAGZ,oBAAiB;KAAjB,iBAAiB;AACnB;;AANA;EAGE,kBAAkB;AAGpB;;AANA;EAIE,iBAAiB;AAEnB;;AANA;EAIE,gBAAiB;AAEnB;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA,mCAAmC;AACnC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;EACrB,gCAAgC;AAClC","sourcesContent":[".multiSelectContainer {\n  position: relative;\n  width: 100%;\n}\n\n.selectInput {\n  display: flex;\n  align-items: center;\n  min-height: 42px;\n  padding: 4px 50px 4px 8px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  background: white;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.15s;\n}\n\n.selectInput:hover {\n  border-color: #9ca3af;\n}\n\n.selectInput:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 2px #dbeafe;\n}\n\n.selectInput.open {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 2px #dbeafe;\n}\n\n.searchIconContainer {\n  position: absolute;\n  right: 32px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n  pointer-events: none;\n}\n\n.searchIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.clearButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 2px;\n  border-radius: 2px;\n  transition: background 0.15s;\n  color: #6b7280;\n  pointer-events: auto;\n}\n\n.clearButton:hover {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n.selectedItems {\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  gap: 4px;\n  flex: 1;\n  align-items: center;\n  min-height: 32px;\n  max-height: 160px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 2px;\n}\n\n.selectedPill {\n  display: flex;\n  align-items: center;\n  background: #f9fafb;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  padding: 3px 4px 3px 6px;\n  font-size: 13px;\n  color: #222;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n  transition: all 0.15s;\n  max-width: min(100%, 220px);\n  min-width: 0;\n  overflow: hidden;\n}\n\n.selectedPill:hover {\n  background: #e5e7eb;\n  border-color: #9ca3af;\n}\n\n.pillFlag {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  margin-right: 5px;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.pillText {\n  display: block;\n  flex: 1;\n  min-width: 0;\n  font-weight: 500;\n  margin-right: 3px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pillRemove {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 1px;\n  border-radius: 2px;\n  transition: background 0.15s;\n  color: #6b7280;\n  flex-shrink: 0;\n  width: auto !important;\n}\n\n.pillRemove:hover {\n  background: #e5e7eb;\n  color: #374151;\n}\n\n.pillCloseIcon {\n  width: 12px;\n  height: 12px;\n}\n\n.searchInput {\n  border: none;\n  outline: none;\n  background: none;\n  font-size: 14px;\n  flex: 1;\n  min-width: 100px;\n  padding: 4px 0;\n  color: #222;\n  width: 100%;\n  text-overflow: ellipsis;\n}\n\n.searchInput::placeholder {\n  color: #9ca3af;\n}\n\n.selectArrow {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #6b7280;\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.selectArrow svg {\n  transition: transform 0.2s;\n}\n\n.selectArrow svg.arrowUp {\n  transform: rotate(180deg);\n}\n\n.dropdown {\n  background: white;\n  border: 1px solid #d1d5db;\n  border-top: none;\n  border-radius: 0 0 4px 4px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.noResults {\n  padding: 12px 16px;\n  text-align: center;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n.dropdownItem {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background 0.15s;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.dropdownItem:last-child {\n  border-bottom: none;\n}\n\n.dropdownItem:hover {\n  background: #f3f4f6;\n}\n\n.dropdownItem.selected {\n  background: #eff6ff;\n}\n\n.dropdownItem.selected:hover {\n  background: #dbeafe;\n}\n\n.dropdownItem.focused {\n  background: #e5e7eb;\n  outline: 2px solid #2563eb;\n  outline-offset: -2px;\n}\n\n.checkbox {\n  margin-right: 8px;\n  cursor: pointer;\n}\n\n.countryFlag {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  margin-right: 8px;\n  object-fit: cover;\n}\n\n.countryName {\n  flex: 1;\n  color: #222;\n}\n\n/* Scrollbar styling for dropdown */\n.dropdown::-webkit-scrollbar {\n  width: 8px;\n}\n\n.dropdown::-webkit-scrollbar-track {\n  background: #f3f4f6;\n  border-radius: 4px;\n}\n\n.dropdown::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 4px;\n}\n\n.dropdown::-webkit-scrollbar-thumb:hover {\n  background: #9ca3af;\n}\n\n/* Firefox scrollbar */\n.dropdown {\n  scrollbar-width: thin;\n  scrollbar-color: #d1d5db #f3f4f6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"multiSelectContainer": `multiSelectContainer--UI5iL`,
	"selectInput": `selectInput--PAjBh`,
	"open": `open--kbAc9`,
	"searchIconContainer": `searchIconContainer--iqWMO`,
	"searchIcon": `searchIcon--H48BR`,
	"clearButton": `clearButton--vZA8w`,
	"selectedItems": `selectedItems--En2bi`,
	"selectedPill": `selectedPill--XVipf`,
	"pillFlag": `pillFlag--DNg8l`,
	"pillText": `pillText--Ebglf`,
	"pillRemove": `pillRemove--PHvYu`,
	"pillCloseIcon": `pillCloseIcon--SJpkF`,
	"searchInput": `searchInput--dAWnk`,
	"selectArrow": `selectArrow--iluRC`,
	"arrowUp": `arrowUp--u46ys`,
	"dropdown": `dropdown--uPpRg`,
	"noResults": `noResults--ja6wf`,
	"dropdownItem": `dropdownItem--O2ROV`,
	"selected": `selected--DCvW_`,
	"focused": `focused--pU2uk`,
	"checkbox": `checkbox--Wswn8`,
	"countryFlag": `countryFlag--Fnnca`,
	"countryName": `countryName--daUmF`
};
export default ___CSS_LOADER_EXPORT___;
